import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import Reveal from "./Reveal";
import { OFFICE } from "../../data/content";

const UbicacionSection = () => {
  return (
    <section id="ubicacion" className="section-ubicacion" data-testid="ubicacion-section">
      <div className="rr-container">
        <div style={{ textAlign: "center", marginBottom: 38 }}>
          <span className="section-eyebrow" style={{ color: "var(--rr-orange-dark)" }}>
            Visite nuestra oficina
          </span>
          <h2 className="section-title font-display">¿Dónde estamos?</h2>
          <p className="section-desc" style={{ margin: "10px auto 0" }}>
            La inmobiliaria y el despacho jurídico se encuentran en la misma dirección.
          </p>
        </div>
        <Reveal className="ubicacion-grid">
          <div className="ubicacion-info">
            <div className="info-row">
              <div className="info-icon">
                <MapPin size={20} />
              </div>
              <div>
                <h5>Dirección</h5>
                <p data-testid="office-address">{OFFICE.address}</p>
              </div>
            </div>
            <div className="info-row">
              <div className="info-icon">
                <Clock size={20} />
              </div>
              <div>
                <h5>Horario</h5>
                <p>{OFFICE.hours}</p>
              </div>
            </div>
            <div className="info-row">
              <div className="info-icon">
                <Phone size={20} />
              </div>
              <div>
                <h5>Teléfono de oficina</h5>
                <p>
                  <a href={OFFICE.phoneTel} style={{ color: "inherit", textDecoration: "none" }} data-testid="ubicacion-phone-link">
                    {OFFICE.phoneDisplay}
                  </a>
                </p>
              </div>
            </div>
            <a
              href={OFFICE.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-orange"
              style={{ marginTop: 6 }}
              data-testid="como-llegar-btn"
            >
              <Navigation size={17} /> Cómo llegar
            </a>
          </div>
          <div className="map-frame" data-testid="map-frame">
            <iframe
              title="Ubicación Inmobiliaria y Despacho Jurídico Rendón Ramos"
              src={OFFICE.mapsEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default UbicacionSection;
